export default function (http) {
    return {
        queryByPage(data) {
            return http.json({
                url: `/merchants/query`,
                data
            });
        },
        /**
         * 获取商家详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/merchants/get?id=${data.id}`
            })
        },
        /**
         * 新增商家
         * @param data
         * @return {*}
         */
        save(data) {
            return http.json({
                url: `/merchants/save`,
                data
            })
        },
        /**
         * 删除商家
         * @param data
         * @return {*}
         */
        removeMerchants(data) {
            return http.json({
                url: `/merchants/delete?id=${data[0].id}`,
                data
            })
        },
        /**
         * 查询商家不分页列表，导出
         * @param data
         * @return {*}
         */
        list(data) {
            return http.json({
                url: `/merchants/list`,
                data
            })
        },


        queryByCode(data) {
            return http.json({
                url: `/system/dict/e/${data.code}`,
                data
            });
        },


        /**
         * 隐藏或显示商家
         * @param data
         * @return {*}
         */
        showOrHidden(data) {
            return http.json({
                url: `/merchants/showOrHidden?id=${data.id}&state=${data.state}`,
                data
            })
        },


    };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/merchants.js